import React from "react";

const ErrorPage404 = () => <div>404</div>;

export default ErrorPage404;
